import React from "react";
import { DownArrowIcon } from "../Icons";

const Accordion = ({
  title,
  children,
  defaultOpen = true,
  contentClassName = "",
}) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);

  return (
    <div
      className="mb-3 overflow-hidden rounded-3xl border border-divider bg-background-surface shadow-sm transition-all duration-300"
    >
      {/* =====================================
          HEADER
      ====================================== */}
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className={`w-full flex items-center justify-between px-4 py-3 transition-all duration-300 ease-in-out
          ${
            isOpen
              ? "bg-background-secondary dark:bg-background-muted"
              : "hover:bg-background-secondary"
          }
        `}
      >
        <span className="text-sm font-medium text-text-primary">{title}</span>

        {/* ICON */}
        <div
          className={`accordion-icon scale-75 !p-2 transition-transform duration-300 ease-in-out ${isOpen ? "rotate-180" : "rotate-0"}`}
        >
          <DownArrowIcon />
        </div>
      </button>

      {/* =====================================
          CONTENT
      ====================================== */}
      <div
        className={`
          grid transition-all duration-300 ease-in-out
          ${
            isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
          }
        `}
      >
        <div className="overflow-hidden">
          <div className={`pt-3 px-4 pb-4 flex flex-col gap-4 border-t border-divider bg-background-base dark:bg-background-surface transition-all duration-300 ${contentClassName} `}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
